const config = require('../../config');

const angularModule = angular.module('config', []);

Object.keys(config).forEach(key => {
	angularModule.constant(key, config[key]);
});
